import WithRender from "../../templates/ui/tooltip.html";
import { mapGetters } from "vuex";

export default WithRender({
  computed: {
    ...mapGetters(["getTooltipContent", "getIsTooltipsActive"]),
    getContent: function () {
      return this.getTooltipContent(this.tooltip);
    },
    getIsMobile: function () {
      return window.innerWidth <= 990;
    }
  },
  methods: {
    getTriggerEvent: function (tooltip) {
      let classes = ["vue-tooltip-theme"];
      if (this.tooltipClass) {
        classes.push(this.tooltipClass);
      }
      return {
        content: tooltip,
        trigger: this.getIsMobile ? "click" : "hover",
        autoHide: false,
        classes
      };
    }
  },
  props: ["tooltip", "tooltipClass"]
});
